// extracted by mini-css-extract-plugin
export default {"notificationText":"Notification_notificationText__RnchZ"};